import OfferTechnologies from './OfferTechnologies'

export default OfferTechnologies
